import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserContext } from './user-context.types';

@Injectable()
export class UserContextService {
  constructor(route: ActivatedRoute) {
    const owningRoute = this.findContext(route, 'userContext');
    this.userContext = owningRoute?.snapshot.data.userContext;
    owningRoute?.data.subscribe((d) => {
      this.userContext = d.userContext;
    });
  }

  private userContext: UserContext;

  get(): UserContext {
    return this.userContext;
  }

  private findContext(route: ActivatedRoute, contextName: string): ActivatedRoute | undefined {
    let currentRoute: ActivatedRoute | null = route;
    while (currentRoute) {
      const snapshot = currentRoute.snapshot;
      if (snapshot.data[contextName] !== undefined) {
        return currentRoute;
      }

      currentRoute = currentRoute.parent;
    }

    return undefined;
  }
}
